// Farsça rakamları İngilizceye çevir
export const toEnglishNumbers = (str) => {
    if (!str) return '';
    
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    
    let result = str.toString();
    
    // Farsça rakamları dönüştür
    for (let i = 0; i < 10; i++) {
        result = result.replace(new RegExp(persianNumbers[i], 'g'), i);
        result = result.replace(new RegExp(arabicNumbers[i], 'g'), i);
    }
    
    return result;
};

// İngilizce rakamları Farsçaya çevir
export const toPersianNumbers = (str) => {
    if (!str) return '';
    
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    
    let result = str.toString();
    
    for (let i = 0; i < 10; i++) {
        result = result.replace(new RegExp(i.toString(), 'g'), persianNumbers[i]);
    }
    
    return result;
};

// Dile göre sayı formatı
export const formatNumbersByLanguage = (str, language) => {
    if (language === 'fa') {
        return toPersianNumbers(str);
    }
    return toEnglishNumbers(str);
};